import apiClient from './client';

/** 目标模式（P9）API 客户端。 */

export type GoalStatus = 'active' | 'completed' | 'blocked' | 'failed' | 'budget_exhausted';

export interface GoalSuccessCriteria {
  type: 'benchmark' | 'llm';
  /** benchmark：评测产物 ID */
  artifact_id?: string;
  /** benchmark：评测套件 ID */
  suite_id?: string;
  /** benchmark：目标综合分阈值（0~1]） */
  target_score?: number;
  /** llm：自由文本验收标准 */
  criteria?: string;
}

export interface Goal {
  id: string;
  agent_id: string;
  objective: string;
  success_criteria: GoalSuccessCriteria;
  status: GoalStatus;
  rounds: number;
  max_rounds: number;
  consecutive_blockers: number;
  blocker_reason: string | null;
  budget_tokens: number | null;
  used_tokens: number;
  stop_requested: boolean;
  job_id: string | null;
  created_at: string | null;
  updated_at: string | null;
  finished_at: string | null;
}

export interface GoalRound {
  id: string;
  goal_id: string;
  round_no: number;
  round_type: 'normal' | 'wrap_up';
  verdict: 'pass' | 'fail' | 'blocked';
  score: number | null;
  action_summary: string;
  blocker: string | null;
  tokens_used: number;
  detail: Record<string, unknown> | null;
  created_at: string | null;
}

export interface GoalCreatePayload {
  objective: string;
  success_criteria: GoalSuccessCriteria;
  max_rounds?: number;
  budget_tokens?: number | null;
}

export async function createGoal(agentId: string, payload: GoalCreatePayload): Promise<{ goal: Goal; job_id: string }> {
  const res = await apiClient.post(`/agents/${agentId}/goals`, payload);
  return res.data;
}

export async function listGoals(agentId: string): Promise<Goal[]> {
  const res = await apiClient.get(`/agents/${agentId}/goals`);
  return res.data;
}

export async function getGoal(goalId: string): Promise<Goal> {
  const res = await apiClient.get(`/goals/${goalId}`);
  return res.data;
}

export async function listGoalRounds(goalId: string): Promise<GoalRound[]> {
  const res = await apiClient.get(`/goals/${goalId}/rounds`);
  return res.data;
}

export async function stopGoal(goalId: string): Promise<Goal> {
  const res = await apiClient.post(`/goals/${goalId}/stop`);
  return res.data;
}

export async function resumeGoal(goalId: string): Promise<{ goal: Goal; job_id: string }> {
  const res = await apiClient.post(`/goals/${goalId}/resume`);
  return res.data;
}
